import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const ImgContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${theme.border.radius.small};

  img {
    width: 500px;
    height: 300px;
    border-radius: ${theme.border.radius.small};
  }
`;

export const ImgRetry = styled.div`
  width: 100%;
  height: 100%;
  border-radius: ${theme.border.radius.small};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  span {
    text-align: center;
    color: ${theme.colors.supportErrorDark};
    display: flex;
    align-items: flex-start;
    user-select: none;

    svg {
      width: 20px;
      height: 20px;
    }

    :hover {
      cursor: pointer;
    }
  }
`;
